module.exports = __webpack_public_path__ + "media/images/d_4-f2f85027eb8a87765f7b766c98d150fa.png";